import { Translation } from '@ps/web-shared-components';
import { isEmpty } from 'lodash';
import React from 'react';

import type { Balance } from '@swf/first';

// TODO refactor to use composition or shared.scss
// eslint-disable-next-line no-restricted-imports
import { container } from '../BalanceRecord/BalanceRecord.scss';

import { TXTWCL_Other_balances } from './OtherBalances.messages.json';
import { title, wrapper } from './OtherBalances.scss';
import InstantBonusBalances from './components/InstantBonusBalances/InstantBonusBalances';
import TournamentMoneyBalances from './components/TournamentMoneyBalances/TournamentMoneyBalances';
import UnclearedBalances from './components/UnclearedBalances/UnclearedBalances';

export interface Props {
  balances: Balance[];
}

const OtherBalances: React.FC<Props> = ({ balances }) => {
  const [instantBonusBalances, tournamentMoneyBalances, unclearedForCashoutBalances]: Balance[][] =
    balances.reduce(
      (result, balance) => {
        if (balance.instantBonusTotal) {
          result[0].push(balance);
        }
        if (balance.tMoney) {
          result[1].push(balance);
        }
        if (balance.unclearedForCashout) {
          result[2].push(balance);
        }
        return result;
      },
      [[], [], []] as Balance[][]
    );

  return instantBonusBalances.length ||
    tournamentMoneyBalances.length ||
    unclearedForCashoutBalances.length ? (
    <div className={wrapper}>
      <div className={title}>
        <Translation {...TXTWCL_Other_balances} />
      </div>
      {!isEmpty(instantBonusBalances) && (
        <div className={container}>
          <InstantBonusBalances balances={instantBonusBalances} />
        </div>
      )}
      {!isEmpty(tournamentMoneyBalances) && (
        <div className={container}>
          <TournamentMoneyBalances balances={tournamentMoneyBalances} />
        </div>
      )}
      {!isEmpty(unclearedForCashoutBalances) && (
        <div className={container}>
          <UnclearedBalances balances={unclearedForCashoutBalances} />
        </div>
      )}
    </div>
  ) : null;
};

export default OtherBalances;
